import styled from 'styled-components'
import { navControlStyles, activeNavControlStyles } from 'components/navigation/common/styles'

type NavigationLinkProps = {
  isActive: boolean
}

export const NavigationLink = styled.div<NavigationLinkProps>`
  ${navControlStyles}

  ${({ isActive }) => isActive && activeNavControlStyles}
`
